import { Apple, Play, Zap, Bell, ArrowRight } from "lucide-react";

/**
 * Promo card inserted at the top of /catalogue and /produit/:id (and other
 * shop pages) to convert web visitors into app downloads. Uses the smart
 * /api/download link that auto-routes iOS → App Store, Android → Play Store.
 */
export const AppPromoCard = ({ compact = false }) => {
  if (compact) {
    return (
      <a
        href="/api/download"
        data-testid="app-promo-card-compact"
        className="group flex items-center gap-4 rounded-2xl bg-gradient-to-r from-[#0E7A3B] to-[#0d6a34] text-white p-4 md:p-5 shadow-[0_10px_30px_rgba(14,122,59,0.2)] hover:-translate-y-0.5 hover:shadow-[0_15px_40px_rgba(14,122,59,0.35)] transition-all duration-300"
      >
        <div className="h-12 w-12 shrink-0 rounded-2xl bg-[#F5A800] flex items-center justify-center">
          <Zap className="h-6 w-6 text-[#16241B]" />
        </div>
        <div className="flex-1">
          <p className="font-display font-bold text-base md:text-lg leading-tight">
            L'expérience Zafara est encore meilleure dans l'app
          </p>
          <p className="text-xs md:text-sm opacity-90 mt-0.5">
            Notifications en direct · paiement 1 clic · flash sales exclusives
          </p>
        </div>
        <ArrowRight className="h-5 w-5 shrink-0 group-hover:translate-x-1 transition-transform" />
      </a>
    );
  }
  return (
    <section
      data-testid="app-promo-card"
      className="relative overflow-hidden rounded-3xl bg-[#16241B] text-white p-6 md:p-8 lg:p-10"
    >
      <div className="pointer-events-none absolute -top-16 -right-16 h-64 w-64 rounded-full bg-[#F5A800]/25 blur-3xl" />
      <div className="pointer-events-none absolute -bottom-20 -left-20 h-64 w-64 rounded-full bg-[#0E7A3B]/40 blur-3xl" />
      <div className="relative grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 items-center">
        <div>
          <p className="font-utility text-xs uppercase tracking-[0.25em] text-[#F5A800]">
            Application mobile
          </p>
          <h3 className="mt-4 font-display text-2xl md:text-3xl lg:text-4xl leading-tight tracking-tight">
            Achetez encore plus vite —
            <br />
            <span className="text-[#F5A800]">dans l'app Zafara.</span>
          </h3>
          <ul className="mt-5 space-y-2 text-sm md:text-base text-white/85">
            <li className="flex items-center gap-2">
              <Bell className="h-4 w-4 text-[#F5A800]" /> Notifications de livraison en direct
            </li>
            <li className="flex items-center gap-2">
              <Zap className="h-4 w-4 text-[#F5A800]" /> Flash sales & bons plans réservés aux mobiles
            </li>
            <li className="flex items-center gap-2">
              <Play className="h-4 w-4 text-[#F5A800] fill-[#F5A800]" /> Paiement Mobile Money en 1 clic
            </li>
          </ul>
          <div className="mt-6 flex flex-wrap gap-3">
            <a
              data-testid="app-promo-appstore"
              href="/api/download"
              className="inline-flex items-center gap-2 rounded-full bg-white text-[#16241B] px-5 py-3 font-semibold hover:bg-[#F5A800] transition-colors"
            >
              <Apple className="h-5 w-5" /> App Store
            </a>
            <a
              data-testid="app-promo-playstore"
              href="/api/download"
              className="inline-flex items-center gap-2 rounded-full bg-[#0E7A3B] text-white px-5 py-3 font-semibold hover:bg-[#F5A800] hover:text-[#16241B] transition-colors"
            >
              <Play className="h-5 w-5 fill-white" /> Google Play
            </a>
          </div>
        </div>
        <div className="hidden md:flex justify-center">
          <div className="relative w-[200px] aspect-[9/19] rounded-[2.5rem] bg-[#0F2A1B] p-3 shadow-[0_30px_70px_rgba(0,0,0,0.4)] rotate-6">
            <div className="relative h-full w-full rounded-[2rem] bg-gradient-to-br from-[#FBFAF6] to-[#E7F3EC] overflow-hidden flex flex-col items-center justify-center">
              <div className="absolute top-3 left-1/2 -translate-x-1/2 h-5 w-20 rounded-full bg-[#0F2A1B]" />
              <div className="mt-4">
                <span className="font-display font-bold text-3xl text-[#0E7A3B]">Za</span>
                <span className="font-display font-bold text-3xl text-[#F5A800]">fara</span>
              </div>
              <p className="mt-2 font-utility text-[10px] uppercase tracking-widest text-[#16241B]/60">
                Bénin
              </p>
              <div className="mt-6 h-16 w-16 rounded-2xl bg-[#F5A800] flex items-center justify-center animate-pulse">
                <Bell className="h-7 w-7 text-[#16241B]" />
              </div>
              <p className="mt-4 px-4 text-center text-xs text-[#16241B]/70">
                Votre commande arrive !
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
